


















































import { Component, Prop, Vue } from 'vue-property-decorator';
import { IProgram } from '../Scripts/ISearchService';
import { msiInfo } from '../Scripts/MsiInfo';

@Component({
	components: {
	},
	directives: {
	}
})
export default class ResultDetailProgram extends Vue {
	@Prop() public item!: IProgram;
	@Prop() public interactive!: boolean;

	public requestMoreInfo (item: IProgram): void {
		this.$emit('request-more-info', item);
	}

	get msiClassifications (): string {
		if (!this.item.msiCodes) return 'N/A';

		return this.item.msiCodes.map(c => msiInfo.getMetadata(c).title).join(', ');
	}
}
